export default __webpack_public_path__ + "apply7f60cb9.png";